import React, { useEffect, useState } from "react";
import { ITransactionArchive } from "../../types/archiveTransactions.type";
import { DatePicker, Input, message, Table, Typography } from "antd";
import { api } from "../../api/api";
import dayjs from "dayjs";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveTransactions() {
  const [transactions, setTransactions] = useState<ITransactionArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/archive/transactions`, {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
          search: searchTerm,
        },
      });
      setTransactions(response.data.transactions);
      setTotal(response.data.total);
      console.log(response.data);
    } catch (error) {
      console.error("Ошибка получение транзакций", error);
      message.error("Ошибка получение транзакций");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, dateRange, searchTerm]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    setPage(1);
  };


  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Касса",
      dataIndex: "cashboxName",
      key: "cashboxName",
    },
    {
      title: "Кассир",
      dataIndex: "cashierName",
      key: "cashierName",
    },
    {
      title: "Описанине",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Баланс до",
      dataIndex: "balanceBefore",
      key: "balanceBefore",
    },
    {
      title: "Баланс после",
      dataIndex: "balanceAfter",
      key: "balanceAfter",
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
      render: (amount: number) => roundToThreeDecimals(amount),
    },
    {
      title: "Доход",
      dataIndex: "profit",
      key: "profit",
      render: (amount: number) => roundToThreeDecimals(amount),
    },
    {
      title: "Курс",
      dataIndex: "exchangeRate",
      key: "exchangeRate",
    },

    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Тип прихода",
      dataIndex: "creditType",
      key: "creditType",
    },
    {
      title: "Тип расхода",
      dataIndex: "expenseType",
      key: "expenseType",
    },
    {
      title: "Имя сотрудника",
      dataIndex: "workerName",
      key: "workerName",
    },
    {
      title: "Имя клиента",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Имя станка",
      dataIndex: "machineName",
      key: "machineName",
    },
    {
      title: "Имя партнёра",
      dataIndex: "partnerName",
      key: "partnerName",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title>Архив Транзакций</Title>
      <Input.Search
        placeholder="Поиск по названию"
        onSearch={handleSearch}
        allowClear
        style={{ width: 300 }}
      />
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />
      <Table
        columns={columns}
        dataSource={transactions}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
